import { featureRegistryReducer } from './registry';
export * from './types';
export * from './registry';
export * from './hooks';

// Static reducers for the feature registry
export const featureRegistryStaticReducers = {
  featureRegistry: featureRegistryReducer,
};
